var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"navigation-child-footer",style:({
    paddingTop: _vm.height+'px',
  })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContent),expression:"showContent"}],ref:"content",staticClass:"navigation-child-footer__content"},[_c('FavouriteTogglerRow',{attrs:{"menu_id":_vm.menu_id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }